export default __webpack_public_path__ + "static/media/awards_bubbles.552991af.png";